import React from 'react';
import {useLocation} from 'react-router';
import Legal from '../pages/Legal';
export default function LegalRoute() {
    return <Legal policy={useLocation().pathname.split('/').filter(Boolean).at(-1)} />;
}
